import React from "react";

import MapContainer from "../components/map/MapContainer";
import Navbar from "../components/navbar/Navbar";

const Company = () => {
  return (
    <>
      <Navbar />
      <MapContainer />
    </>
  );
};

export default Company;
